import React, { FC, useState } from "react";
import { TimeSlot } from "./types";
import { TimeDropdown } from "./TimeDropdown";

interface TimePickerInputProps {
  value?: string;
  onChange?: (slot: TimeSlot) => void;
  className?: string;
  mode: "add" | "edit";
  referenceDate?: Date;
  type?: "startTime" | "endTime";
  slots: TimeSlot[];
  futureDays?: number;
}

const TimePickerInput: FC<TimePickerInputProps> = ({
  value,
  onChange,
  className,
  mode,
  referenceDate,
  type,
  slots,
  futureDays,
}) => {
  const [internalValue, setInternalValue] = useState<string>("9:00 am");

  const isControlled = onChange !== undefined;
  const currentValue = isControlled ? (value ?? "") : internalValue;

  const handleChange = (slot: TimeSlot) => {
    if (isControlled) {
      onChange!(slot);
    } else {
      setInternalValue(slot.label);
    }
  };

  return (
    <TimeDropdown
      value={currentValue}
      onChange={handleChange}
      className={className}
      mode={mode}
      referenceDate={referenceDate}
      type={type}
      slots={slots}
      futureDays={futureDays}
    />
  );
};

export default TimePickerInput;
